import { mapGetters } from 'vuex';

function toProperCase(originString) {
  return originString.charAt(0).toUpperCase() + originString.slice(1);
}

export function makeGetters(stateNames) {
  let getters = {};

  stateNames.forEach(stateName => {
    let properStateName = toProperCase(stateName);

    getters[`get${properStateName}`] = state => {
      return state[stateName];
    };
  });

  return getters;
}

export function makeSetters(stateNames) {
  let setters = {};

  stateNames.forEach(stateName => {
    let properStateName = toProperCase(stateName);

    setters[`set${properStateName}`] = (state, value) => {
      state[stateName] = value;
    };
  });

  return setters;
}

export function computedGetters(stateNames, namespace) {
  let getters = {};

  stateNames.forEach(stateName => {
    let properStateName = toProperCase(stateName);

    if (namespace) {
      return (getters[stateName] = `${namespace}/get${properStateName}`);
    }

    getters[stateName] = `get${properStateName}`;
  });

  return mapGetters(getters);
}
